// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import * as types from './actionTypes';

export function requestLogin(data, toCheckout, isNewCustomer) {
  return {
    type: types.LOGIN_REQUEST,
    data,
    toCheckout,
    isNewCustomer,
  };
}

export function onLoginResponse(response) {
  return {
    type: types.LOGIN_RESPONSE,
    response
  };
}
export function loginFailed(error) {
  return {
    type: types.LOGIN_FAILED,
    error
  };
}

export function resetCommonError() {
  return {
    type: types.RESET_COMMON_ERROR,
    commonError: null,
  };
}

// LOGIN FIELDS

export function changeField(value, field) {
  return {
    type: types.LOGIN_FIELD_CHANGE,
    value,
    field
  };
}

export function changeErrors(field, error) {
  return {
    type: types.LOGIN_ERRORS_CHANGE,
    field,
    error
  };
}
